import { Resources } from '@shared/localizations/Resources';
import { PlacedFrom } from '@shared/utils/Trading/PlacedFrom';
import { PositionActionEnum } from '@shared/utils/Trading/PositionActionEnum';
import { getActionEnability, processAction } from './PositionsPanelActionsProcessor';
const toolbarActions = [
    PositionActionEnum.All,
    PositionActionEnum.CLXAll,
    PositionActionEnum.Negative,
    PositionActionEnum.Positive,
    PositionActionEnum.ByAccountAndInstrument,
    PositionActionEnum.Short,
    PositionActionEnum.Long,
    PositionActionEnum.ClosePositionMkt,
    PositionActionEnum.ReverseByInstrument,
    PositionActionEnum.ReverseByIds,
    PositionActionEnum.CLXByAccountAndInstrument
];
function getActionText(action, selectedPositions) {
    var _a;
    const firstInstrument = (_a = selectedPositions[0]) === null || _a === void 0 ? void 0 : _a.getInstrument();
    switch (action) {
        case PositionActionEnum.All:
            return Resources.getResource('panels.positions.buttons.closeAll');
        case PositionActionEnum.CLXAll:
            return Resources.getResource('panels.positions.buttons.clxAll');
        case PositionActionEnum.Negative:
            return Resources.getResource('panels.positions.buttons.closeNegative');
        case PositionActionEnum.Positive:
            return Resources.getResource('panels.positions.buttons.closePositive');
        case PositionActionEnum.ByAccountAndInstrument:
            return getActionTextForInstrument(Resources.getResource('panels.positions.buttons.closeForInstrument'), firstInstrument);
        case PositionActionEnum.Short:
            return Resources.getResource('panels.positions.buttons.closeShort');
        case PositionActionEnum.Long:
            return Resources.getResource('panels.positions.buttons.closeLong');
        case PositionActionEnum.ClosePositionMkt:
            return Resources.getResource('panels.positions.buttons.closeSelected');
        case PositionActionEnum.ReverseByInstrument:
            return getActionTextForInstrument(Resources.getResource('panels.positions.buttons.reverse'), firstInstrument);
        case PositionActionEnum.ReverseByIds:
            return Resources.getResource('panels.positions.buttons.reverseSelected');
        case PositionActionEnum.CLXByAccountAndInstrument:
            return getActionTextForInstrument(Resources.getResource('panels.positions.buttons.clxForInstrument'), firstInstrument);
        default:
            return '';
    }
}
function getActionTextForInstrument(actionText, instrument) {
    if (isNullOrUndefined(instrument)) {
        return actionText;
    }
    return `${actionText} ${instrument.getName()}`;
}
export function createToolbarActions(allPositions, selectedPositions, appSettings, tradingProvider, applicationScreensProvider) {
    return toolbarActions.map((action) => {
        const actionAccessResponse = getActionEnability(action, allPositions, selectedPositions, tradingProvider);
        return {
            id: action,
            text: getActionText(action, selectedPositions),
            tooltip: isValidString(actionAccessResponse.notAllowedReason) ? actionAccessResponse.notAllowedReason : '',
            disabled: actionAccessResponse.isAllowed === false,
            onClick: () => {
                processAction(action, allPositions, selectedPositions, appSettings, tradingProvider, applicationScreensProvider, PlacedFrom.WEB_POSITIONS_PANEL_HOT_BTN);
            }
        };
    });
}
